import { ExceptionService } from '../services/exception.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TogetherDIPStageContainer } from 'app/models/app.models';
import { DipStateService } from 'app/services/dip-state-service.service';
import { NodeAPIEntityService } from 'app/services/node.entity.service';
import { TogetherAuctionDIPEntityType } from 'app/models/enums';
import { TogetherAuctionDIPOutcome_DIP } from 'app/models/api.models';

@Component({
    selector: 'application-outcome',
    templateUrl: './application-outcome.component.html',
    styleUrls: ['./application-outcome.component.scss'],
    standalone: false
})
export class ApplicationOutcomeComponent implements OnInit {
  /**
   * The current stage
   *
   * @type {TogetherDIPStageContainer}
   * @memberof ApplicationOutcomeComponent
   */
  @Input() stage: TogetherDIPStageContainer;
  /**
   * Notify that stage is changing
   *
   * @type {EventEmitter<string>}
   * @memberof ApplicationOutcomeComponent
   */
  @Output() stageChanging: EventEmitter<string> = new EventEmitter<string>();
  /**
   * The id of the case geing processed
   *
   * @type {string}
   * @memberof ApplicationOutcomeComponent
   */
  @Input() caseId: string;

  outcome: Object;
  /**
   * Get loading status from state
   *
   * @readonly
   * @type {boolean}
   * @memberof ApplicationOutcomeComponent
   */
  get IsLoading(): boolean {
    return this.state.IsLoading;
  }

  constructor(private state: DipStateService,
    private entity: NodeAPIEntityService,
    private exception: ExceptionService) { }

  ngOnInit() {
    this.state.IsLoading = true;
    this.entity.getAllEntities(TogetherAuctionDIPEntityType.Detail, this.caseId)
      .subscribe(
        (success: Object) => {
          this.outcome = new TogetherAuctionDIPOutcome_DIP(success);
          this.state.IsLoading = false;
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this.state.IsLoading = false;
        },
      );
  }

}
